/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.monetization.rpc.BadgeInAppService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './BadgeInAppService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.monetization.rpc.BadgeInAppService#getProductBadges
 */
export const GET_PRODUCT_BADGES_QUERY_FIELD_NAME = 'com_hubspot_monetization_rpc_BadgeInAppService_getProductBadges';
export const GET_PRODUCT_BADGES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCT_BADGES_QUERY_FIELD_NAME,
  args: ['productApiNames', 'seatCount'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProductBadgesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});